/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recurring_LabelInputs */

const en_recurring_label = /** @type {(inputs: Recurring_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`recurring`)
};

const he_recurring_label = /** @type {(inputs: Recurring_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חוזר`)
};

/**
* | output |
* | --- |
* | "recurring" |
*
* @param {Recurring_LabelInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const recurring_label = /** @type {((inputs?: Recurring_LabelInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recurring_LabelInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recurring_label(inputs)
	return he_recurring_label(inputs)
});